module.exports = __webpack_public_path__ + "img/resultado-sustentavel.89a48298.jpg";